export enum InternalCompanyEnum {
  CLARO = "claro",
  ATOZ = "atoz",
}

/**
 *  Map to display texts for each company.
 *
 *  TODO: store in Database by tenant.
 */
export const COMPANY_TEXT_MAP: Record<InternalCompanyEnum, CompanyDisplay> = {
  [InternalCompanyEnum.CLARO]: {
    name: "Claro Insurance",
    short_name: "Claro",
    name_split: "Claro",
    legal_name: "All Insurance Inc dba Claro Insurance",
    possesive_name: `Claro's`,
  },
  [InternalCompanyEnum.ATOZ]: {
    name: "AtoZ Agents",
    short_name: "AtoZ",
    name_split: "A to Z",
    legal_name: "Insurance XL Inc dba AtoZ Agents",
    possesive_name: "AtoZ",
  },
};

export interface CompanyDisplay {
  name: string;
  short_name: string;
  name_split: string;
  legal_name: string;
  possesive_name: string;
}
